import { Controller } from 'stimulus'
import { useClickOutside } from 'stimulus-use'
import $ from 'jquery'
import './sidebar_nav_component.css'
import { runAfterTransitionsComplete } from '~/common/helpers/animation'

export default class extends Controller {
  connect() {
    useClickOutside(this)
  }

  toggleSidebar() {
    if (this.isPositionFixed()) {
      this.element.classList.add('is-animating')
      void this.element.offsetWidth
      this.#setOpen(!this.element.classList.contains('is-open'))
      runAfterTransitionsComplete(this.element, () => {
        this.element.classList.remove('is-animating')
      })
    } else {
      this.element.classList.toggle('is-collapsed')
      this.initializeTooltips(this.element)

      localStorage.setItem(
        'community-sidebar-nav-collapsed',
        this.isCollapsed()
      )
    }
  }

  closeSidebar() {
    if (this.isPositionFixed() && this.element.classList.contains('is-open')) {
      this.toggleSidebar()
    }
  }

  clickOutside(e) {
    if (
      this.isPositionFixed() &&
      !e.target.closest('.js-logo-and-nav-toggle-container')
    ) {
      this.#setOpen(false)
    }
  }

  #setOpen(open) {
    if (this.element.classList.contains('is-open') === open) return

    this.element.classList.toggle('is-open', open)
    this.dispatch(open ? 'opened' : 'closed')
  }

  isPositionFixed() {
    return !!this.element.closest('.nav-sidebar-position-fixed')
  }

  isCollapsed() {
    return this.element.classList.contains('is-collapsed')
  }

  toggleChildrenOrNavigate(e) {
    if (e.target.closest('.js-navigate-to-link-on-click')) {
      return
    }

    e.preventDefault()
    e.stopImmediatePropagation()
    this.dispatch('toggleChildren', { target: e.target })
  }

  saveLinkChildrenCollapsedState(e) {
    if (!this.isPositionFixed() && this.isCollapsed()) {
      this.toggleSidebar()
    }

    this.initializeTooltips(e.currentTarget)
    e.currentTarget
      .querySelector('.js-children-chevron-icon')
      .classList.toggle('fa-rotate-90', e.detail.visible)

    localStorage.setItem(
      `community-sidebar-nav-link-${e.currentTarget.dataset.linkId}-collapsed`,
      !e.detail.visible
    )
  }

  initializeTooltips(elm) {
    setTimeout(() => $(elm).changed(), 1)
  }
}
